import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Typography } from '@mui/material';

type ShareLinkProps = {
    textToCopy: string;
};

const ShareLink: React.FC<ShareLinkProps> = ({ textToCopy }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Hide message after 2s
        } catch (error) {
            console.error('Failed to copy:', error);
        }
    };

    return (
        <div style={{ display: 'inline-block', verticalAlign: 'center' }}>
            <button
                onClick={handleCopy}
                style={{
                    background: 'none',
                    border: 'none',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    padding: 0,
                }}
            >
                <ContentCopyIcon />
            </button>
            {copied && (
                <Typography variant='caption' sx={{marginLeft: 2, verticalAlign: 'center', fontSize: 'medium'}}>
                    Shareable link copied to your clipboard
                </Typography>
            )}
        </div>
    );
};

export default ShareLink;